import { Link, useRouterState } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

// Tabs across the admin pages the navbar's "Admin" item leads to. The queue
// is not among them: it has its own top-level navbar item. V2 pill-tab styling
// (tabs.css `etn-tabs--pill`), reused here as plain router links rather than
// Radix Tabs since each destination is a real route, not a tab panel.
const ITEMS = [
  { to: '/admin/kb', label: 'Manage articles', match: (p: string) => p.startsWith('/admin/kb') },
  { to: '/admin/view-as', label: 'View as user', match: (p: string) => p === '/admin/view-as' },
  { to: '/admin/email-log', label: 'Email log', match: (p: string) => p === '/admin/email-log' },
  { to: '/admin/learnings', label: 'Learnings', match: (p: string) => p === '/admin/learnings' },
  { to: '/admin/settings', label: 'Settings', match: (p: string) => p === '/admin/settings' },
] as const

export function AdminSubNav() {
  const path = useRouterState({ select: s => s.location.pathname })

  return (
    <nav className="mb-6 flex items-center gap-1">
      {ITEMS.map(item => {
        const active = item.match(path)
        return (
          <Link
            key={item.to}
            to={item.to as never}
            className={cn(
              'rounded-etn-pill px-3 text-etn-control font-semibold transition-colors h-[var(--etn-control-height-sm)] inline-flex items-center',
              active
                ? 'bg-etn-accent-tint text-etn-accent-text-active'
                : 'text-etn-text-label hover:bg-etn-surface-sunken hover:text-etn-text',
            )}
          >
            {item.label}
          </Link>
        )
      })}
    </nav>
  )
}
